import ActionsForm from '@/shared/mixins/actionsForm'
import registerFilter from './components/registerFilter/registerFilter.vue'
import registerTable from './components/registerTable/registerTable.vue'
// import Tools from '@/components/tools/Tools.js'

export default {
  name: 'registerApr',
  components: {registerFilter, registerTable},
  mixins: [ActionsForm],
  props: {
    lista: {
      type: Array,
      requered: false
    }
  },
  data () {
    return {
      details: false
    }
  },
  mounted () {
  },
  methods: {
    detalhesApr () {
      this.details = true
    },
    search (data) {
      this.$refs.registerTable.formSearch = data
      this.$refs.registerTable.onLoad()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/registerApr/registerApr.js